import script from "./MultiLingualText.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiLingualText.vue?vue&type=script&setup=true&lang=js"

import "./MultiLingualText.vue?vue&type=style&index=0&id=769efb48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-769efb48"]])

export default __exports__